import { adminCommerceMessages } from './admin-commerce'
import { trailerMessages } from './trailer'

export const zhCN = {
  adminCommerce: adminCommerceMessages['zh-CN'],
  trailerRefresh: trailerMessages['zh-CN'],
  home: {
    quotaFull: '订阅已达当前额度，可查看会员方案。',
    search: '搜索番号、女优或标题',
    updates: '我的订阅动态',
    updatesBody: '你关注的女优，作品更新都在这里。',
    following: '我关注的女优',
    followingBody: '选择一位，只看她的动态。',
    discover: '随便看看吧',
    discoverBody: '从片库随机挑选一些作品，看看有没有你喜欢的。',
    shuffle: '换一批',
    scrollPrevious: '{section}：向左滑动',
    scrollNext: '{section}：向右滑动',
    favorites: '收藏回顾',
    favoritesBody: '回到你保存的作品 · 按发行日期排列',
    noSubscriptionsBody: '从一位喜欢的女优开始。订阅后，她的作品会出现在这里。',
    noUpdates: '关注的人暂时没有作品动态',
    noUpdatesBody: '你的订阅会保留，也可以先去发现更多作品。',
    noFavorites: '还没有收藏。看到喜欢的作品，点一下爱心，下次就能在这里找到。',
    noDiscovery: '暂无可展示的作品，稍后再来看看。',
  },

  admin7: {
    overviewHint: '本地业务数据；外部依赖健康未经探测',
    orders: '订单核查',
    config: '必要配置',
    content: '内容维护',
    tasks: '任务管理',
    empty: '暂无记录',
    unknown: '请求结果未知，请查询原请求回执。不要重新提交。',
    recover: '查询原请求',
    receipt: '已确认回执',
    newRequest: '发起另一项操作',
    requestKey: '请求键',
    role: '角色',
    saveRole: '确认修改角色',
    user: '普通用户',
    admin: '管理员',
    details: '查看详情',
    save: '保存',
    readBack: '读回当前状态',
    loading: '读取中…',
    email: '邮箱',
    userId: '用户 ID',
    id: '记录 ID',
    status: '状态',
    source: '来源',
    editActressSource: '修正女优抓取来源',
    sourceIdentifier: 'JavBus 来源 ID',
    currentSource: '当前来源 ID',
    sourceHint: '保存仅修正来源，不启动抓取。需要更新资料时，请另行选择刷新女优资料。',
    sourceFormat: '1–80 个英文字母、数字、下划线或短横线，首位为字母或数字',
    sourceConflict: '来源已被修改，请先重新读取当前值，再决定是否保存。',
    reloadSource: '重新查询来源',
    continueEditing: '继续编辑',
    trailerMaintenance: '单影片预告维护',
    trailerHint: '仅处理所选影片。新预告成功前保留已有资产；入队后按任务状态确认，可申请取消。',
    trailerMode: '补源方式',
    trailerAuto: '自动发现',
    trailerUrl: '公开预告 URL',
    trailerFile: '本地预告文件',
    trailerUrlHint: '支持 DMM、MGS、加勒比等已允许的公开预告路径；其他来源请使用本地文件。',
    trailerFileHint: 'MP4 或 MPEG-TS，最大 200 MiB；文件内容由服务端核验。',
    uploading: '正在上传并等待回执，请保留此页；超时后只查询原任务。',
    all: '全部',
    amount: '金额',
    created: '创建时间',
    paid: '支付时间',
    expires: '到期时间',
    providerStatus: '提供方状态',
    merchantOrder: '商户订单号',
    orderHint: '只读核查 Payment 订单；不含独立 Stars 账本，不触发查单或发放权益。各币种分别显示。',
    revenue: '本月 CCPayment 已付（USD）',
    revenueHint: 'UTC 月界，仅 USD；不含 Stars、CDKey 或手动权益',
    limit: '每日免费注册名额',
    translationUrl: '翻译服务地址',
    model: '翻译模型',
    translationKey: '翻译 API 密钥',
    appId: 'CCPayment App ID',
    paymentKey: 'CCPayment 密钥',
    fiat: '计价法币 ID',
    coin: '计价币 ID',
    configured: '已配置；留空保留',
    unset: '未配置',
    configHint: '密钥不读回原值；空白保留。保存后返回脱敏配置，不代表外部服务已验证。',
    recent: '抓取近期内容',
    actressCrawl: '抓取女优作品',
    videoRefresh: '刷新影片',
    actressRefresh: '刷新女优资料',
    translateVideo: '翻译单片',
    translateBatch: '有界批量翻译',
    kind: '操作',
    target: '目标内部 ID',
    pages: '最大页数（1–10）',
    batchLimit: '批量上限（1–50）',
    enqueue: '确认入队',
    taskHint: '入队不表示执行完成。离开页面不会取消任务；取消只作用于所选任务。',
    active: '活动任务',
    history: '历史任务',
    cancelTask: '申请取消此任务',
    cancellation: '已申请取消，等待执行端终态',
    progress: '处理 {processed} / {total} · 成功 {success} · 失败 {failed}',
    attempts: '尝试 {attempts} / {max}',
    errorCode: '错误码',
    taskId: '任务 ID',
    searchActress: '搜索本地女优',
    searchVideo: '搜索影片番号或标题',
    searchBound: '输入至少 2 个字符，最多显示 20 条',
    noContent: '未找到匹配内容，请调整搜索词',
    selectedContent: '已选择：{name}',
    search: '查询',
    select: '选择',
    unavailableStar: '缺少 JavBus Star ID',
    translationTitle: '人工修正译题',
    videoId: '影片内部 ID',
    locale: '语言',
    title: '标题',
    translationSaved: '译题已保存',
    viewUser: '管理权益',
    snapshot: '当前权益结束时间',
    manualHint: '默认追加到有效权益之后；已过期从当前时间起算。终身权益不可降级。',
    months: '月数（1–120）',
    expectedEnd: '预计结束时间（以服务端回执为准）',
    membershipConflict: '权益快照或请求发生冲突，请重新读取用户状态后再操作。',
    replaceLifetimeEffect: '替换后为终身权益，没有到期时间。',
    replaceFiniteEffect: '替换后从本次生效时间起计算 {months} 个月，当前剩余时长不保留，可能缩短权益。',
    append: '追加权益',
    replace: '替换权益',
    mode: '权益操作',
    reason: '操作备注',
    replaceConfirm: '确认以所选计划替换当前权益，可能缩短有效期',
  },
  brand: { name: 'JAV Tracker', admin: '管理后台' },
  nav: {
    today: '今日',
    discover: '发现',
    library: '片库',
    search: '搜索',
    me: '我的',
    searchPlaceholder: '搜索番号、女优、标签',
    account: '账户菜单',
    logout: '退出登录',
    admin: '管理后台',
    language: '语言',
    back: '返回',
    backTo: '返回 {target}',
    skipToContent: '跳到主要内容',
  },
  common: {
    retry: '重试',
    loading: '加载中…',
    loadMore: '继续加载',
    loadError: '加载失败，请重试',
    networkError: '网络连接失败',
    cancel: '取消',
    apply: '应用',
    clearAll: '清除全部',
    confirm: '确认',
    close: '关闭',
    copy: '复制',
    copied: '已复制',
    copyFailed: '复制失败，请手动选择复制',
    videosCount: '{count} 部',
    viewAll: '查看全部',
    upgrade: '升级',
    end: '已经到底了',
    autoPaused: '已加载 {count} 部，继续浏览请手动加载',
    unknownOutcome: '请求结果未知，正在向服务器确认…',
    unknownPending: '请求结果尚未确认，请查询状态后再继续。',
    verifyState: '查询状态',
    mockNotice: 'Mock 数据预览 · 所有内容均为合成示例',
  },
  video: {
    retranslate: '重新翻译',
    retranslateHint: '重新翻译本片标题，保留人工修订；完成后自动更新译文。',
    new: '新',
    magnets: '磁力 {count}',
    noMagnets: '等待磁力',
    trailer: '预告',
    solo: '独演',
    favorite: '收藏',
    favorited: '已收藏',
    unfavorite: '取消收藏',
    copyCode: '复制番号',
    coverAlt: '{code} 封面',
    coverFallback: '封面',
    releaseDate: '发行日',
    duration: '时长',
    minutes: '{count} 分钟',
    maker: '制作商',
    series: '系列',
    cast: '出演',
    tags: '标签',
    translated: '译文',
    original: '日文原文',
    playTrailer: '播放预告片',
    closeTrailer: '关闭预告',
    trailerLabel: '{code} 预告片',
    trailerError: '预告片加载或播放失败，请重试。',
    trailerUnsupported: '当前浏览器不支持此预告格式，请换用支持 MediaSource 的浏览器。',
    trailerPlayBlocked: '浏览器暂停了自动播放，请使用下方播放控件。',
    trailerHint: '预告只在点击后加载。',
    noTrailer: '暂无预告片',
    copyBest: '复制最佳磁力',
    bestMeta: '{size} · 做种 {seeders} · {source}',
    bestRule: '按做种与体积自动挑选',
    noMagnetYet: '暂无磁力，可尝试刷新',
    allMagnets: '全部磁力',
    magnetCount: '{count} 条',
    refreshMagnets: '刷新磁力',
    refreshQuota: '今日剩余 {remaining}/{limit}',
    refreshing: '正在刷新…',
    colName: '名称',
    colSize: '体积',
    colSeeders: '做种',
    colSource: '来源',
    best: '最佳',
    notFound: '找不到这部影片',
    notFoundBody: '番号可能有误，或者尚未入库。可以试试在线搜索。',
  },
  actress: {
    recrawl: '再次抓取',
    recrawlHint: '抓取并入库近期作品，最多扫描 5 页；完成后自动刷新作品列表。',
    subscribe: '订阅',
    subscribed: '已订阅',
    pending: '确认中…',
    unknown: '重新确认',
    unsubscribe: '取消订阅',
    works: '作品',
    soloOnly: '独演',
    withCompilations: '含合集',
    pushing: '新作会推送到你的 Telegram',
    pushOff: '绑定 Telegram 后可接收新作推送',
    debut: '出道',
    birthday: '生日',
    height: '身高',
    measurements: '三围',
    videoTotal: '作品',
    limitReached: '免费版最多订阅 5 位女优',
    notFound: '找不到这位女优',
  },
  today: {
    title: '今日追更',
    summary: '自上次访问以来 {count} 部新作 · 订阅 {actresses} 位女优',
    all: '全部',
    manage: '管理订阅',
    hasMagnets: '有磁力',
    hasTrailer: '有预告',
    unfavorited: '未收藏',
    sortRelease: '按发行日',
    today: '今天',
    yesterday: '昨天',
    groupCount: '{count} 部',
    emptyNoSubs: '还没有订阅任何女优',
    emptyNoSubsBody: '订阅后，她们的新作会按发行日出现在这里。',
    goDiscover: '去发现女优',
    emptyFiltered: '当前筛选下没有作品',
    emptyFilteredBody: '换个筛选条件，或者清除筛选看看全部动态。',
    quotaTitle: '免费版 · 订阅女优',
    quotaFull: '已达上限，会员可无限订阅并去除广告',
    viewPlans: '查看会员方案',
  },
  discover: {
    title: '发现',
    videos: '影片',
    actresses: '女优',
    tags: '标签',
    filter: '筛选',
    filterCount: '筛选 · {count}',
    filterDraft: '草稿 · 未应用',
    applied: '已应用：',
    onlyShow: '仅显示',
    solo: '独演作品',
    hasMagnets: '有磁力',
    hasTrailer: '有预告',
    favorited: '我收藏的',
    releaseWindow: '发行时间',
    anyTime: '不限',
    days30: '30 天',
    thisYear: '今年',
    tag: '标签',
    sortLabel: '影片排序',
    sortNewest: '发行日期 · 新到旧',
    sortOldest: '发行日期 · 旧到新',
    sortCrawledNewest: '抓取日期 · 新到旧',
    sortCrawledOldest: '抓取日期 · 旧到新',
    pageAt: '正在看第 {page} 页',
    jump: '跳转',
    jumpLabel: '跳到页码',
    actressFilter: '名字、日文名、罗马音',
    all: '全部',
    subscribedOnly: '已订阅',
    unsubscribedOnly: '未订阅',
    hotTags: '热门标签',
    hotTagsHint: '按全站收藏数',
    searchTags: '搜索全部标签',
    expand: '展开其余 {count}',
    collapse: '收起',
    tagFilterActive: '标签：{name}',
  },
  tagCategory: {
    QUALITY_FORMAT: '画质与格式',
    RELEASE_LABEL: '发行厂牌',
    BODY_PERSONA: '身材与人设',
    ROLE_COSTUME: '角色与服装',
    RELATION_CAST: '关系与阵容',
    GENRE_SCENARIO: '题材与场景',
    PLAY_FETISH: '玩法与偏好',
    OTHER: '其他',
  },
  library: {
    title: '片库',
    favorites: '收藏影片 · {count}',
    favoritesTab: '收藏影片',
    subscriptions: '订阅女优 · {count}',
    favoritedAt: '{actress}',
    latest: '最新 {code}',
    quota: '免费版额度',
    emptyFavorites: '还没有收藏的影片',
    emptyFavoritesBody: '在任何影片卡片上点心形即可收藏。',
    emptySubs: '还没有订阅女优',
  },
  search: {
    title: '搜索',
    placeholder: '搜索番号、女优、标签',
    scopeAll: '全部',
    scopeVideos: '影片',
    scopeActresses: '女优',
    scopeTags: '标签',
    exact: '番号精确命中',
    videos: '影片',
    actresses: '女优',
    tags: '标签',
    open: '↵ 打开',
    recent: '最近搜索',
    clearRecent: '清除',
    noLocal: '本地没找到想要的？在线搜索 JavBus',
    onlineHint: '结果会入库；缓存命中不扣次数',
    onlineButton: '在线搜索「{keyword}」',
    onlineQuota: '今日剩余 {remaining}/{limit}',
    onlineRunning: '正在在线搜索… 已找到 {count} 部',
    onlineDone: '在线搜索完成，找到 {count} 部',
    onlineCancel: '停止',
    onlineCancelled: '已停止接收结果；已入库的作品不会撤销',
    onlineExhausted: '今日在线搜索次数已用完',
    keyboardHints: '↑↓ 选择 · ↵ 打开 · Esc 关闭',
    typeToSearch: '输入至少 2 个字符',
    searching: '搜索中…',
    noResult: '本地没有匹配结果',
    kindCode: '番号',
    kindVideo: '影片',
    kindActress: '女优',
    kindTag: '标签',
  },
  me: {
    defaultLanguage: '默认语言',
    defaultLanguageHint: '用于新作 Telegram 通知和详情链接；未设置时使用繁体中文。界面语言可独立切换。',
    defaultLanguageSaved: '默认语言已保存',

    title: '我的',
    overview: '概览',
    membership: '会员与支付',
    telegram: 'Telegram 推送',
    cdkey: '兑换 CDKey',
    security: '语言与安全',
    free: '免费版',
    active: '会员',
    expired: '已过期',
    lifetime: '终身会员',
    until: '有效期至 {date}',
    verifyBanner: '邮箱尚未验证：兑换 CDKey、购买会员和绑定 Telegram 前需要先验证。',
    resendVerify: '重发验证邮件',
    verifySent: '验证邮件已排队，请稍后查收',
    quotaSubs: '订阅女优',
    quotaOnline: '在线搜索 · 今日',
    quotaRefresh: '刷新磁力 · 今日',
    perks: '会员：无限订阅与额度、去广告。加密货币支付，确认到账后自动开通。',
    monthly: '月度',
    yearly: '年度',
    lifetimePlan: '终身',
    perMonth: '/ 月',
    perYear: '/ 年',
    oneTime: '一次性',
    bestValue: '最划算',
    choose: '选择{plan}',
    price: '[价格]',
    orderPaid: '支付成功，会员权益已生效。',
    orderCancelled: '订单已关闭，未据此开通会员。',
    orderUnknown: '支付订单仍待确认，请查询原订单，不要重复创建。',
    goCheckout: '前往支付',
    checkOrder: '查询原订单',
    tgUnknown: '操作结果尚未确认，请检查绑定状态；不要自动重复发送请求。',
    tgRegenerate: '重新获取会替换旧绑定码。',
    tgCopy: '复制绑定命令',
    tgOpenBot: '打开机器人',
    tgCheck: '检查绑定状态',
    cdkeyConfirm: '确认原兑换请求',
    cdkeyUnknown: '兑换结果未知，已重新读取会员状态。可确认原兑换请求，不要更换兑换码重复提交。',
    orderPending: '订单已创建，等待支付确认。关闭页面不影响到账，权益以服务器确认为准。',
    tgBound: '已绑定 @{username}',
    tgUnbound: '未绑定',
    tgBody: '订阅女优有新作时推送。首次绑定可领取 7 天会员。',
    tgRewarded: '首次绑定奖励已领取',
    tgTest: '发送测试消息',
    tgTestSent: '测试消息已排队发送',
    tgUnbind: '解绑',
    tgBind: '获取绑定码',
    tgCode: '在 Telegram 中向机器人发送：{code}',
    cdkeyLabel: '输入兑换码',
    cdkeyRedeem: '兑换',
    cdkeyNeedVerify: '验证邮箱后可用',
    cdkeyDone: '兑换成功，会员已开通',
    cdkeyHint: 'Mock 可用兑换码：DEMO-CDKEY-2026',
    language: '界面语言',
    changePassword: '修改密码',
    logout: '退出登录',
  },
  auth: {
    login: '登录',
    register: '注册',
    email: '邮箱',
    password: '密码',
    optional: '选填',
    forgot: '忘记密码？',
    submitLogin: '登录',
    submitRegister: '创建账号',
    demoLink: '先逛逛访客 Demo →',
    passwordRule: '至少 8 位，包含英文字母和数字，最多 72 字节（中文和表情占多个字节）',
    headline: '订阅女优，\n新作第一时间送到你手里。',
    mockHint: 'Mock 账号：demo@example.com 或 admin@example.com，密码 password1',
    terms: '服务条款',
    privacy: '隐私政策',
    forgotTitle: '找回密码',
    forgotBody: '输入注册邮箱。已绑定 Telegram 的账号会优先发到 Telegram，否则发送邮件。',
    forgotSubmit: '发送重置链接',
    forgotDoneTitle: '请求已提交',
    forgotDone: '如账号符合条件，系统会安排发送重置链接。此提示不代表已送达；可在 {seconds} 秒后重新申请。',
    forgotResend: '重新发送',
    forgotPrivacy: '提交后的提示对所有邮箱一致，不透露账号是否存在。',
    backToLogin: '返回登录',
    forgotHeadline: '忘了密码也没关系，\n你追的人还在。',
    resetTitle: '设置新密码',
    resetBody: '完成后所有设备会退出登录。',
    newPassword: '新密码',
    confirmPassword: '再输入一次',
    show: '显示',
    hide: '隐藏',
    ruleLength: '至少 8 位（表情等可能计为两位）',
    ruleBytes: '最多 72 字节（中文和表情占多个字节）',
    ruleMix: '包含字母和数字',
    ruleMatch: '两次输入一致',
    resetSubmit: '保存新密码',
    resetExpired: '链接已过期或已使用？',
    resetAgain: '重新申请 →',
    resetDone: '密码已更新，请重新登录',
    resetHeadline: '换一把新钥匙，\n其他设备会自动退出。',
    verifyingTitle: '正在验证邮箱…',
    verifiedTitle: '邮箱已验证',
    verifiedBody: '现在可以兑换 CDKey、购买会员，并绑定 Telegram 接收新作推送。',
    goBindTelegram: '去绑定 Telegram',
    backToday: '回到今日',
    verifyFailedTitle: '邮箱验证未完成',
    verifyFailedBody: '请查看错误提示；链接失效时可登录后重新申请验证邮件。',
    registerEmailFailed: '账号已创建，验证邮件暂未确认排队；可在账户页重新申请。',
    alreadyVerified: '邮箱已验证',
    currentPassword: '当前密码',
    logoutAll: '退出所有网页会话',
    logoutAllDone: '网页会话已退出，请重新登录',
    resendVerify: '重新发送验证邮件',
    goLogin: '去登录',
  },
  jobs: {
    nextPage: '在线搜索下一页',
    cancelling: '已请求取消，等待确认',
    confirmRequest: '确认原请求',
    resume: '重新连接任务',
    unknown: '提交结果尚未确认。确认原请求会使用同一个请求编号，不会重复创建已存在的任务。',
    disconnected: '任务仍可能继续运行，连接中断不会取消任务。可重新连接查看状态。',
    partial: '已取得部分可用结果；额度按可用结果结算。',
  },
  onboarding: {
    step1: '选女优',
    step2: '收藏影片',
    step3: '连接 Telegram',
    step4: '完成',
    progress: '{current} / 1 · {label}',
    skip: '跳过引导',
    title: '先选几位你想追的女优',
    body: '推荐 3 位，最多 5 位。她们的新作会出现在「今日」，也可以推送到 Telegram。',
    selected: '已选 {count} / 5',
    continue: '订阅 {count} 位并继续',
    needOne: '至少选 1 位',
  },
  landing: {
    navigation: '首页导航',
    eyebrow: '你的私人追更清单',
    signupFree: '创建免费账号',
    heroA: '关注你喜欢的，',
    heroB: '新作不再错过。',
    heroBody: '把关注的女优、想留住的作品和新作动态放在一起。打开 JAV Tracker，先看与你有关的更新。',
    seePreview: '看看如何追更',
    loginHint: '登录后浏览作品、管理订阅与收藏。注册名额以注册页为准。',
    previewTitle: '我的订阅动态',
    example: '追更示例',
    sampleOne: '关注女优的新作，整理在一起',
    sampleTwo: '值得留意的作品，随手收藏',
    sampleAvailable: '磁力已收录',
    previewNote: '绑定 Telegram，也可以接收新作通知。',
    exampleNote: '以上为功能示意，番号与内容均为合成示例，不代表实时更新。',
    how: '如何使用',
    howTitle: '从关注开始，让追更成为日常。',
    f1Title: '找到想关注的人',
    f1Body: '搜索女优名字、番号或标题，查看作品与女优资料。',
    f2Title: '订阅，建立自己的动态',
    f2Body: '关注的女优集中管理，作品按发行日期整理；喜欢的影片可以单独收藏。',
    f3Title: '回来看看，或接收通知',
    f3Body: '在首页查看订阅动态。主动绑定 Telegram 后，也可以在那里接收新作通知。',
    pricingTitle: '免费开始，按需选择会员',
    pricingBody:
      '免费账号可浏览作品、收藏影片和订阅女优。订阅及在线操作有额度限制，当前可用额度会在登录后显示。',
    membershipBody: '需要更多额度时，再查看会员方案。实际权益、价格与购买可用状态以账号内展示为准。',
    viewMembership: '登录查看会员方案',
    startTitle: '先关注一位喜欢的女优。',
    startBody: '让下一次打开首页，有值得期待的内容。',
    sessionError: '暂时无法确认登录状态，你仍可阅读首页。',
    termsTitle: '服务说明',
    termsBody:
      'JAV Tracker 是面向成年人的资料管理与新作追踪工具。第三方作品信息可能延迟或失效，请在所在地允许的范围内使用。',
    termsContact: '索取完整服务条款 ↗',
    privacyTitle: '隐私说明',
    privacyBody:
      '登录使用 Cookie 维持会话；订阅、收藏与账号关联。Telegram 绑定由你主动开启，也可在账号内解绑。此处为功能说明，完整政策及数据相关请求请联系支持。',
    privacyContact: '隐私政策与数据咨询 ↗',
    rights: '© JAV Tracker',
  },
  admin: {
    overview: '仪表盘',
    users: '用户',
    crawler: '爬虫控制台',
    groupOverview: '概览',
    groupUsers: '用户与收入',
    groupContent: '内容',
    groupCrawl: '采集',
    groupSystem: '系统',
    revenue: '收入',
    cdkeys: 'CDKey',
    videos: '影片',
    aliases: '女优别名',
    translations: '翻译任务',
    crawlerLogs: '爬虫日志',
    config: '系统配置',
    monitor: '监控',
    notInScope: '首版暂未开放',
    backToApp: '← 返回前台',
    refresh: '刷新',
    telegramTest: '发送 Telegram 测试',
    statVideos: '影片',
    statActresses: '女优',
    statUsers: '用户',
    statRevenue: '本月收入',
    statTranslations: '待翻译',
    statQueue: '后台队列失败',
    delta24h: '+{count} 近 24 小时',
    delta7d: '+{count} 近 7 天',
    activeMembers: '有效会员 {count}',
    sinceMonth: '北京时间月初起',
    ingest: '入库新作 · 近 14 天',
    sample: 'Mock 数据',
    deps: '外部依赖',
    recentJobs: '最近后台任务',
    usersSub: '{count} 位用户 · 管理员不受邮箱验证限制',
    searchEmail: '搜索邮箱',
    filterAll: '全部',
    filterActive: '有效会员',
    filterFree: '免费',
    filterExpired: '已过期',
    filterAdmin: '管理员',
    colEmail: '邮箱',
    colRole: '角色',
    colMembership: '会员',
    colTelegram: 'Telegram',
    colSubs: '订阅',
    colCreated: '注册',
    roleAdmin: '管理员',
    roleUser: '用户',
    bound: '已绑定',
    unbound: '未绑定',
    activate: '激活会员',
    activateTitle: '手动激活会员',
    current: '当前：{status}',
    activateFooter: '按套餐标价计入收入，并写入审计。',
    activateConfirm: '确认激活',
    activateDone: '已激活 {email}',
    pageOf: '第 {page} 页',
    prev: '上一页',
    next: '下一页',
    crawlerSub: '内置调度每 3 小时入队 · 仅 normal 分类',
    startIncremental: '启动全站增量',
    jobTitle: '作品抓取 · normal',
    running: '运行中',
    finished: '本轮完成',
    stop: '请求停止',
    slice: '本轮 slice · 影片 {processed} / {total}',
    sliceMeta: '页 {pages} / {pageLimit} · {elapsed}s / {budget}s',
    okCount: '本轮成功',
    failCount: '失败',
    failHint: '将在下一 slice 重试',
    notifyCount: '新作通知',
    notifyHint: '已写入推送队列',
    slots: '全局并发槽',
    slotsHint: '跨实例共享',
    crawlActress: '抓取单个女优',
    starLabel: 'JavBus 女优 ID 或名字',
    enqueue: '加入队列',
    enqueueDone: '已加入队列：{jobId}',
    enqueueHint: '同一女优已有任务时直接返回现有任务，不重复创建。',
    liveLogs: '实时日志',
    liveHint: '每 5 秒刷新',
    forbidden: '需要管理员权限',
  },
  membership: {
    FREE: '免费',
    ACTIVE: '有效',
    EXPIRED: '已过期',
    MONTHLY: '月度',
    YEARLY: '年度',
    LIFETIME: '终身',
  },
} as const
